import script from "./ClickOutside.vue?vue&type=script&lang=js"
export * from "./ClickOutside.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__